/* Internal imports */
import { ETAPES_DOSSIER_MAROQUINERIE, SECTIONS_MAROQUINERIE } from '../../constantes/ROUTES/MAROQUINERIE';
import { getMaroquinerieArborescence } from '../../../routes/private-routes/epargne/maroquinerie/MaroquinerieArborescence';

const getUrlFromEtapeIndex = (etapeIndex) => {
  return getMaroquinerieArborescence().find(route => route.etapeIndex === etapeIndex).path || "";
}

const getEtapeIndexFromUrl = (url) => {
  return getMaroquinerieArborescence().find(route => route.path === url).etapeIndex || 0;
}

const getEtapeIndexFromEtapeDossier = (etapeDossier) => {
  return ETAPES_DOSSIER_MAROQUINERIE[etapeDossier];
}
const getUrlFromEtapeDossier = (etapeDossier) => {
  return getMaroquinerieArborescence().find(route => route.etapeIndex === ETAPES_DOSSIER_MAROQUINERIE[etapeDossier]).path || "";
}

const isInFirstSection = (route) => {
  return route.etapeIndex < SECTIONS_MAROQUINERIE.BESOIN.ETAPE;
}

const isInSecondSection = (route) => {
  return (
    route.etapeIndex >= SECTIONS_MAROQUINERIE.BESOIN.ETAPE
    && route.etapeIndex < SECTIONS_MAROQUINERIE.ADHESION.ETAPE
  );
}

const isLastStepTunnel = (url) => {
  return getMaroquinerieArborescence().find(route => route.path === url).etapeIndex === ETAPES_DOSSIER_MAROQUINERIE.INFORMATIONS;
}

const getSectionIndexFromUrl = (url) => {
  const route = getMaroquinerieArborescence().find(route => route.path === url);

  if (!route || isInFirstSection(route)){
    return SECTIONS_MAROQUINERIE.ENTREPRISE.INDEX;
  }

  if (isInSecondSection(route)) {
    return SECTIONS_MAROQUINERIE.BESOIN.INDEX;
  }

  return SECTIONS_MAROQUINERIE.ADHESION.INDEX;
}

export default {
  getUrlFromEtapeIndex,
  getEtapeIndexFromUrl,
  getEtapeIndexFromEtapeDossier,
  getUrlFromEtapeDossier,
  isInFirstSection,
  isInSecondSection,
  isLastStepTunnel,
  getSectionIndexFromUrl
}